import React from 'react';
import './Legal.css';

const ChildSafety = () => {
  return (
    <div className="legal-page">
      <div className="page-header">
        <div className="container">
          <h1>子どもの安全基準に関するポリシー</h1>
        </div>
      </div>
      
      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h2>（1）コミュニティガイドライン</h2>
              <p>本アプリでは、児童の性的虐待や搾取（CSAE）を厳格に禁止しています。ユーザーは、児童に対する不適切な行動を促進する行為を行うことはできません。</p>
              <p>また、未成年者の性的対象化やチャイルドグルーミングを助長する内容は一切認められません。</p>
            </div>

            <div className="legal-section">
              <h2>（2）CSAMへの対処</h2>
              <p>児童性的虐待に関連するコンテンツ（CSAM）が確認された場合、速やかに削除し、該当する法律に従って必要な機関に報告します。</p>
            </div>

            <div className="legal-section">
              <h2>（3）法律遵守の自己認定</h2>
              <p>当アプリは、児童保護に関するすべての法律および規制を厳守しています。発見されたCSAMについては、インターネット・ホットラインセンターへ適切に通知を行います。</p>
            </div>

            <div className="legal-section">
              <h2>（4）ユーザーフィードバックの方法</h2>
              <p>ユーザーは、アプリ内の通報機能を利用して、不適切な行為やコンテンツについて簡単に報告できます。</p>
            </div>

            <div className="legal-section">
              <h2>（5）不適切なコンテンツの禁止</h2>
              <p>本アプリでは、過剰な暴力表現や身体的な否定的イメージを助長する内容の掲載を一切禁止しています。</p>
            </div>

            <div className="legal-section">
              <h2>（6）児童の安全を担当する連絡先の提供</h2>
              <p>児童の安全に関するご質問や懸念については、以下のメールアドレスまでご連絡ください</p>
              <p className="contact-email">support@golmachi.net</p>
            </div>

            <div className="legal-section">
              <h2>（7）プライバシーポリシー</h2>
              <p>当アプリは、児童のプライバシーを最優先とし、個人情報の取り扱いに細心の注意を払います。</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChildSafety;